import {Injectable, Injector} from "@angular/core";

import {ReportError} from "app/app.service";
import {BaseListService} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TagPostureSnapshotService extends BaseListService<Models.TagPostureSnapshotListRequest, Models.BatchRequest, Models.TagPostureSnapshot>
{
    constructor(inj: Injector)
    {
        super(inj, Models.TagPostureSnapshot);
    }

    @ReportError
    public list(listReq: Models.TagPostureSnapshotListRequest): Promise<Models.ListResponse>
    {
        return this.domain.apis.tagPosturesApi.snapshotList(listReq);
    }

    @ReportError
    protected getBatchResponseImpl(req: Models.BatchRequest): Promise<Models.TagPostureSnapshotBatchResponse>
    {
        return this.domain.apis.tagPosturesApi.snapshotBatch(req);
    }

    protected createBatchRequest(listRequest: Models.TagPostureSnapshotListRequest,
                                 ids: string[]): Models.BatchRequest
    {
        return Models.BatchRequest.newInstance({ids: ids});
    }
}
